import {Column, HeaderProps} from 'react-table'
import SelectionHeader from '../../../utils/components/table-content/SelectionHeader'
import {ListViewContext} from '../../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../../utils/components/table-content/SelectionCell'
import {PropsWithChildren} from 'react'
import {CustomHeader} from '../../../utils/components/table-content/CustomHeader'
import {IArticleList} from '../core/_model'
import ArticleAction from './ArticleAction'

const articleColumn = (handleSelect: (id: number) => void): ReadonlyArray<Column<IArticleList>> => [
  {
    Header: (props) => <SelectionHeader tableProps={props} context={ListViewContext} />,
    id: 'selection',
    Cell: ({...props}) => (
      <SelectionCell id={props.data[props.row.index].id} context={ListViewContext} />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IArticleList>>) => (
      <CustomHeader tableProps={props} title='title' className='min-w-100px' />
    ),
    id: 'title',
    accessor: 'title',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IArticleList>>) => (
      <CustomHeader tableProps={props} title='category name' className='min-w-100px' />
    ),
    id: 'category_name',
    accessor: 'category_name',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IArticleList>>) => (
      <CustomHeader tableProps={props} title='username' className='min-w-100px' />
    ),
    id: 'user_name',
    accessor: 'user_name',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IArticleList>>) => (
      <CustomHeader tableProps={props} title='Action' className='min-w-100px text-end' />
    ),
    id: 'action',
    Cell: ({...props}) => (
      <ArticleAction id={props.data[props.row.index].id} handleSelect={handleSelect} />
    ),
  },
]

export default articleColumn
